import { Component } from '@angular/core';
import { ORCIDRecordLinkEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Record Links') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidrecordlink-form',
    templateUrl: './orcidrecordlink.form.component.html'
})
export class ORCIDRecordLinkFormComponent extends BaseFormComponent {
    public record!: ORCIDRecordLinkEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

